__turbopack_context__.v({
  "centered": "Label-module__Oxlu3q__centered",
  "label": "Label-module__Oxlu3q__label",
  "labelDisabled": "Label-module__Oxlu3q__labelDisabled",
  "transition": "Label-module__Oxlu3q__transition",
  "verticalMiddle": "Label-module__Oxlu3q__verticalMiddle",
  "verticalTop": "Label-module__Oxlu3q__verticalTop",
});
